import { StaffIdDocumentRules } from '../../lib/types/models/staff/staff-id-document-rules'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export const getStaffIdDocumentRules = async (id: number) => {
  return restApiClient
    .url(constructApiUrl(API.staffs.getIdDocumentRules.url, { id }))
    .get<StaffIdDocumentRules>()
}
